export type Language = "en_GB" | "sv_SE";

export const DEFAULT_LANGUAGE: Language = "en_GB";

export function isLanguage(value: string): value is Language {
  return value === "en_GB" || value === "sv_SE";
}
